import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { db } from "../../firebase"; // 🔥 Firestore 가져오기
import { collection, query, where, getDocs } from "firebase/firestore"; // Firestore 함수
import styles from "./Overview.module.css";

const Overview = () => {
  const { id } = useParams();
  const [companyInfo, setCompanyInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // name이 undefined일 경우 예외 처리
  const companyId = id ? decodeURIComponent(id) : "";

  // Firestore에서 회사 데이터 가져오기
  useEffect(() => {
    if (!companyId) {
      setError("Company name is missing in URL.");
      setLoading(false);
      return;
    }

    const fetchCompanyInfo = async () => {
      try {
        const q = query(
          collection(db, "companies"),
          where("name", "==", companyId)
        );
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          setCompanyInfo(querySnapshot.docs[0].data()); // 첫 번째 문서 사용
        } else {
          setError("Company not found");
        }
      } catch (err) {
        console.error("회사 정보를 불러오는 중 오류 발생:", err);
        setError("Failed to load company information.");
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyInfo();
  }, [companyId]);

  // 로딩 중 상태
  if (loading) {
    return <h2 className={styles.loading}>Loading...</h2>;
  }

  // 에러 상태
  if (error) {
    return <h2 className={styles.notFound}>{error}</h2>;
  }

  return (
    <div className={styles.container}>
      {/* 카드형 테이블 디자인 */}
      <div className={styles.card}>
        <div className={styles.header}>
          <h3>{companyInfo.name}</h3>
          <span>{companyInfo.industry}</span>
        </div>

        <div className={styles.infoGrid}>
          <div className={styles.infoItem}>
            <span className={styles.label}>CEO</span>
            <span className={styles.value}>{companyInfo.ceo}</span>
          </div>
          <div className={styles.infoItem}>
            <span className={styles.label}>Established</span>
            <span className={styles.value}>{companyInfo.established}</span>
          </div>
          <div className={styles.infoItem}>
            <span className={styles.label}>Number of Shares</span>
            <span className={styles.value}>{companyInfo.shares}</span>
          </div>
          <div className={styles.infoItem}>
            <span className={styles.label}>Par Value</span>
            <span className={styles.value}>{companyInfo.parValue}</span>
          </div>
          <div className={styles.infoItem}>
            <span className={styles.label}>Employees</span>
            <span className={styles.value}>{companyInfo.employees}</span>
          </div>
          <div className={styles.infoItem}>
            <span className={styles.label}>Call</span>
            <span className={styles.value}>{companyInfo.call}</span>
          </div>
          <div className={`${styles.infoItem} ${styles.fullWidth}`}>
            <span className={styles.label}>Website</span>
            <span className={styles.value}>
              <a
                href={`https://${companyInfo.website}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {companyInfo.website}
              </a>
            </span>
          </div>
          <div className={`${styles.infoItem} ${styles.fullWidth}`}>
            <span className={styles.label}>Address</span>
            <span className={styles.value}>{companyInfo.address}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overview;
